<template>
  <div>
    <Header parent="sms_settings">
      <template #actions>
        <BaseDatepickerInput v-model="range" ranged />
      </template>
    </Header>

    <!-- <PageContainer>
     
    </PageContainer> -->
     <WhiteTable
        :rows="history"
        :columns="[
          {
            text: $t('sms_history.col_date'),
            key: 'created_at',
            width: 120,
            format: 'date',
          },
          {
            text: $t('sms_history.col_time'),
            key: 'created_at',
            width: 120,
            format: 'time',
          },
          {
            text: $t('sms_history.col_type'),
            width: 200,
            key: 'source_type',
            renderer: v => $t('balance_table.sms_types.'+v.source_type)
          },
          {
            text: $t('sms_history.col_text'),
            key: 'content',
          },
          {
            text: $t('sms_history.col_segments'),
            width: 100,
            key: 'segments_count',
          },
          {
            text: $t('sms_history.col_cost'),
            key: 'public_cost_usd',
            format: 'suffix',
            suffix: '$',
            width: 120,
            renderer: (v) => `${v.public_cost_usd.toFixed(3)} $`
          },
          {
            text: $t('sms_history.col_receiver'),
            key: 'recipient',
            width: 160,
          },
          
        ]"
      />
  </div>
</template>

<style scoped>
</style>

<script>
import SmsAPI from "@/api/sms";

import moment from "moment";

import WhiteTable from "@/components/base/WhiteTable.vue";

export default {
  data() {
    return {
      range: {
        start: null,
        end: null,
      },
      history: [],
    };
  },
  watch: {
    range: {
      deep: true,
      handler() {
        if (this.range.end) this.fetchData();
      },
    },
  },
  methods: {
    fetchData() {
      SmsAPI.getHistory(
        this.$store.state.cafe._id,
        moment(this.range.start).startOf("day").valueOf(),
        moment(this.range.end).endOf("day").valueOf()
      )
        .then((data) => {
          this.history = data.history;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {
    this.range.start = moment().subtract(1, "month").startOf("day").toDate();
    this.range.end = moment().toDate();
  },
  components: {
    WhiteTable,
  },
};
</script>